// සුවඩි Extraction Modal - Modular Modal Component
import React, { useState } from 'react';
import { WarrantyIcon } from './WarrantyIcon';
import type { ExtractionModalProps, ExtractedData } from './types';

export const ExtractionModal: React.FC<ExtractionModalProps> = ({ 
  isOpen, 
  onClose, 
  extractedData, 
  onSave 
}) => {
  const [formData, setFormData] = useState<ExtractedData>(extractedData);
  
  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div 
      className="warranty-extraction-modal-overlay" 
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="extraction-modal-title"
    >
      <div 
        className="warranty-extraction-modal-content" 
        onClick={e => e.stopPropagation()}
      >
        <div className="warranty-extraction-modal-header">
          <h3 id="extraction-modal-title">
            <WarrantyIcon name="brain" className="warranty-extraction-modal-icon" />
            Extracted Warranty Information
          </h3>
          <button 
            onClick={onClose} 
            className="warranty-extraction-modal-close"
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="warranty-extraction-modal-body">
          <div className="warranty-extraction-grid">
            <div className="warranty-extraction-field">
              <label htmlFor="product-name">Product Name</label>
              <input 
                id="product-name"
                type="text" 
                value={formData.productName || ''} 
                onChange={e => setFormData({...formData, productName: e.target.value})}
                className="warranty-extraction-field-input"
                aria-describedby="product-name-help"
              />
              <small id="product-name-help" className="warranty-field-help">
                Enter the full product name
              </small>
            </div>
            
            <div className="warranty-extraction-field">
              <label htmlFor="brand">Brand</label>
              <input 
                id="brand"
                type="text" 
                value={formData.brand || ''} 
                onChange={e => setFormData({...formData, brand: e.target.value})}
                className="warranty-extraction-field-input"
                aria-describedby="brand-help"
              />
              <small id="brand-help" className="warranty-field-help">
                Manufacturer or brand name
              </small>
            </div>
            
            <div className="warranty-extraction-field">
              <label htmlFor="purchase-date">Purchase Date</label>
              <input 
                id="purchase-date"
                type="date" 
                value={formData.purchaseDate || ''} 
                onChange={e => setFormData({...formData, purchaseDate: e.target.value})}
                className="warranty-extraction-field-input"
                aria-describedby="purchase-date-help"
              />
              <small id="purchase-date-help" className="warranty-field-help">
                Date when the product was purchased
              </small>
            </div>
            
            <div className="warranty-extraction-field">
              <label htmlFor="warranty-period">Warranty Period</label>
              <input 
                id="warranty-period"
                type="text" 
                value={formData.warrantyPeriod || ''} 
                onChange={e => setFormData({...formData, warrantyPeriod: e.target.value})}
                className="warranty-extraction-field-input"
                placeholder="e.g., 2 years, 12 months"
                aria-describedby="warranty-period-help"
              />
              <small id="warranty-period-help" className="warranty-field-help">
                Duration of warranty coverage
              </small>
            </div>
            
            <div className="warranty-extraction-field warranty-extraction-field-full">
              <label htmlFor="store">Store/Retailer</label>
              <input 
                id="store"
                type="text" 
                value={formData.purchaseStore || ''} 
                onChange={e => setFormData({...formData, purchaseStore: e.target.value})}
                className="warranty-extraction-field-input"
                aria-describedby="store-help"
              />
              <small id="store-help" className="warranty-field-help">
                Store or retailer where purchased
              </small>
            </div>
          </div>
          
          <div className="warranty-extraction-modal-footer">
            <button 
              type="button"
              onClick={onClose} 
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="btn btn-primary"
            >
              <WarrantyIcon name="warranty-shield" />
              Save Warranty
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExtractionModal;
